import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import UploadSection from './components/UploadSection';
import DataList from './components/DataList';
import ClientAccounts from './components/ClientAccounts';
import EmailSetup from './components/EmailSetup';

type Tab = 'upload' | 'data' | 'clients';

export default function Admin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<Tab>('clients');

  if (!user || user.role !== 'admin') {
    navigate('/login');
    return null;
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center">
              <i className="ri-shield-user-line text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-lg font-bold text-gray-900">Admin Dashboard</h1>
              <p className="text-xs text-gray-500">Manage clients, projects, and documents</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-logout-box-line"></i>
            Logout
          </button>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8 space-y-6">
        {/* Email Setup Card */}
        <EmailSetup />

        {/* Tabs */}
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
          <div className="border-b border-gray-200 flex">
            <button
              onClick={() => setActiveTab('clients')}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'clients'
                  ? 'text-gray-900 border-b-2 border-gray-900 bg-gray-50'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              <i className="ri-team-line mr-2"></i>
              Client Accounts
            </button>
            <button
              onClick={() => setActiveTab('upload')}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'upload'
                  ? 'text-gray-900 border-b-2 border-gray-900 bg-gray-50'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              <i className="ri-upload-2-line mr-2"></i>
              Upload Documents
            </button>
            <button
              onClick={() => setActiveTab('data')}
              className={`flex-1 px-6 py-4 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'data'
                  ? 'text-gray-900 border-b-2 border-gray-900 bg-gray-50'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              <i className="ri-file-list-3-line mr-2"></i>
              All Documents
            </button>
          </div>

          <div className="p-6">
            {activeTab === 'clients' && <ClientAccounts />}
            {activeTab === 'upload' && <UploadSection />}
            {activeTab === 'data' && <DataList />}
          </div>
        </div>
      </div>
    </div>
  );
}